/**
 * Textos (`es`) del tall «nonconformities» de Qualitat i APPCC (OBR-169). Tall propi: no es toca `es.ts`.
 * Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const nonConformitiesEs = {
  'backoffice.nonConformities': {
    subtitle: 'Registro único de no conformidades y de sus acciones correctoras',
    newNonConformity: 'Nueva no conformidad',

    // Lista y filtros
    searchLabel: 'Buscar',
    searchPlaceholder: 'Código, descripción, proveedor, artículo o lote',
    filterStatusLabel: 'Estado',
    filterStatusActive: 'Activas',
    filterStatusAll: 'Todas',
    filterOriginLabel: 'Origen',
    filterOriginAll: 'Todos los orígenes',
    filterFromLabel: 'Desde',
    filterToLabel: 'Hasta',
    clearFilters: 'Borrar los filtros',
    loadError: 'No se han podido cargar las no conformidades',
    empty: 'Todavía no hay ninguna no conformidad.',
    emptyActive: 'No hay ninguna no conformidad activa. Todo en orden.',
    emptyFiltered: 'Ninguna no conformidad coincide con los filtros.',

    // Estados y orígenes
    statusOpen: 'Abierta',
    statusInProgress: 'En curso',
    statusClosed: 'Cerrada',
    originReception: 'Recepción',
    originSelfCheck: 'Autocontrol',
    originProduction: 'Producción',
    originManual: 'Manual',
    originOther: 'Otros',

    // Tarjeta
    occurredAtLabel: 'Cuándo',
    reportedByLabel: 'Comunicada por',
    unknownUser: 'Persona desconocida',
    automaticNoDetail: 'Abierta automáticamente, sin más detalle.',
    actionsProgress: '{{closed}} de {{total}} acciones cerradas',
    actionsNone: 'Sin acciones correctoras',
    actionsOverdue_one: '{{count}} acción vencida',
    actionsOverdue_other: '{{count}} acciones vencidas',
    openDetail: 'Abrir',

    // Enlaces
    linkSupplier: 'Proveedor',
    linkArticle: 'Artículo',
    linkSupplierLot: 'Lote del proveedor',
    linkFinishedLot: 'Lote producido',
    linkReception: 'Albarán',
    linkIncident: 'Incidencia',
    linkSelfCheck: 'Autocontrol',
    linkIncidentOpen: 'Ver la incidencia',
    linkSelfCheckOpen: 'Ver los autocontroles',
    supplierLotCodeRef: 'lote del proveedor {{code}}',

    // Detalle
    sectionSummary: 'Qué ha pasado',
    sectionLinks: 'Origen',
    sectionAttachment: 'Foto o documento',
    sectionActions: 'Acciones correctoras',
    sectionHistory: 'Historial',
    occurredAt: 'Fecha y hora',
    reportedBy: 'Comunicada por',
    closedBanner: 'Cerrada el {{date}} por {{name}}: {{note}}',
    openAttachment: 'Abrir el archivo',
    attachmentError: 'No se ha podido abrir el archivo.',
    readOnlyHint: 'Solo administración, calidad y producción pueden cambiarla.',

    // Cambios de estado
    moveToInProgress: 'Poner en curso',
    moveToOpen: 'Volver a abierta',
    closeNonConformity: 'Cerrar la no conformidad',
    reopenNonConformity: 'Reabrir la no conformidad',
    closeBlockedActions_one: 'Para cerrarla hay que cerrar antes {{count}} acción correctora.',
    closeBlockedActions_other: 'Para cerrarla hay que cerrar antes {{count}} acciones correctoras.',
    closeTitle: 'Cerrar la no conformidad',
    closeBody:
      'Una no conformidad cerrada, con sus acciones, no se puede tocar hasta que se reabra.',
    closeNoteLabel: 'Nota de cierre',
    closeNotePlaceholder: 'Qué se ha hecho y por qué se da por resuelta',
    closeConfirm: 'Cerrar',
    reopenTitle: 'Reabrir la no conformidad',
    reopenBody: 'Vuelve a estar abierta y se puede volver a trabajar. El motivo queda en el historial.',
    reopenNoteLabel: 'Motivo',
    reopenNotePlaceholder: 'Por qué se vuelve a abrir',
    reopenConfirm: 'Reabrir',

    // Acciones correctoras
    addAction: 'Añadir una acción',
    actionsEmpty: 'Todavía no hay ninguna acción correctora.',
    actionsLockedHint: 'Reabre la no conformidad para añadir o cambiar acciones.',
    actionNewTitle: 'Nueva acción correctora',
    actionEditTitle: 'Editar la acción correctora',
    actionDescriptionLabel: 'Qué hay que hacer',
    actionDescriptionPlaceholder: 'Por ejemplo: limpiar y desinfectar la cámara',
    actionResponsibleLabel: 'Responsable',
    actionNoResponsible: 'Sin responsable',
    actionDueOnLabel: 'Fecha límite',
    actionAddConfirm: 'Añadir',
    actionSaveConfirm: 'Guardar',
    editAction: 'Editar',
    startAction: 'Poner en curso',
    backToOpenAction: 'Volver a abierta',
    closeAction: 'Cerrar la acción',
    reopenAction: 'Reabrir la acción',
    actionStatusOpen: 'Abierta',
    actionStatusInProgress: 'En curso',
    actionStatusClosed: 'Cerrada',
    actionOverdue: 'Vencida',
    actionResponsibleLine: 'Responsable: {{name}}',
    actionDueLine: 'Fecha límite: {{date}}',
    actionVerifiedLine: 'Verificada por {{name}} el {{date}}',
    actionVerificationLine: 'Verificación: {{note}}',
    verifyTitle: 'Cerrar la acción correctora',
    verifyBody: 'Para darla por hecha hay que dejar qué se ha comprobado. Queda en el historial.',
    verifyLabel: 'Verificación',
    verifyPlaceholder: 'Qué se ha comprobado',
    verifyConfirm: 'Cerrar la acción',

    // Historial
    historyEmpty: 'Todavía no hay ningún movimiento.',
    eventCreated: 'Comunicada',
    eventStatusChanged: 'Estado: {{from}} → {{to}}',
    eventActionAdded: 'Acción añadida: {{note}}',
    eventActionUpdated: 'Acción modificada: {{note}}',
    eventActionMoved: 'Acción: {{from}} → {{to}}. {{note}}',
    eventClosed: 'Cerrada: {{note}}',
    eventReopened: 'Reabierta: {{note}}',
    eventByLine: '{{name}} · {{date}}',

    // Formulario de NC manual
    manualTitle: 'Nueva no conformidad',
    manualBody:
      'Comunica una no conformidad que has visto. Se crea abierta y el sistema le asigna el código.',
    manualDescriptionLabel: 'Qué ha pasado',
    manualDescriptionPlaceholder: 'Por ejemplo: harina recibida con el saco roto',
    manualSupplierLabel: 'Proveedor (opcional)',
    manualArticleLabel: 'Artículo (opcional)',
    manualLotLabel: 'Lote del proveedor (opcional)',
    manualLotPickArticle: 'Elige primero el artículo para ver sus lotes.',
    manualLotNone: 'Sin lote',
    manualLotNoLots: 'Este artículo todavía no tiene ningún lote de entrada.',
    manualLotLoadError: 'No se han podido cargar los lotes.',
    manualAttachmentLabel: 'Foto o documento (opcional)',
    manualAttachmentChoose: 'Elegir un archivo',
    manualAttachmentHint: 'JPEG, PNG o PDF, hasta 10 MB.',
    manualAttachmentRemove: 'Quitar el archivo',
    manualCreateConfirm: 'Crear',
    searchSupplier: 'Busca un proveedor',
    noSupplierMatches: 'Ningún proveedor coincide',
    searchArticle: 'Busca un artículo',
    noArticleMatches: 'Ningún artículo coincide',
    noneOption: '—',

    // Validación y errores del servidor
    validationDescriptionRequired: 'Escribe qué ha pasado.',
    validationActionDescriptionRequired: 'Escribe qué hay que hacer.',
    errorGeneric: 'No se ha podido guardar el cambio. Vuelve a intentarlo.',
    errorForbidden: 'No tienes permiso para hacer este cambio.',
    errorNotFound: 'Esta no conformidad ya no existe.',
    errorAlreadyClosed: 'Otra persona ya ha cerrado esta no conformidad.',
    errorNotClosed: 'Esta no conformidad no está cerrada.',
    errorOpenActions: 'Todavía hay acciones correctoras sin cerrar.',
    errorNoteRequired: 'Hay que escribir una nota.',
    errorVerificationRequired: 'Para cerrar la acción hay que indicar qué se ha comprobado.',
    errorDescriptionRequired: 'Hay que escribir una descripción.',
    errorClosedLocked: 'La no conformidad está cerrada: reábrela para tocar sus acciones.',
    errorResponsibleOnlyStatus:
      'El responsable solo puede cambiar el estado y la verificación de la acción.',
    errorUploadInvalidType: 'El archivo debe ser JPEG, PNG o PDF.',
    errorUploadTooLarge: 'El archivo pasa de 10 MB.',
    errorUploadFailed: 'No se ha podido subir el archivo. Comprueba la conexión y vuelve a intentarlo.',

    // Resumen de una NC automática (recepción)
    reasonTemperatureRange: 'Temperatura de {{temperature}} ºC fuera de rango ({{min}} a {{max}} ºC)',
    reasonTemperatureAbove: 'Temperatura de {{temperature}} ºC por encima del máximo ({{max}} ºC)',
    reasonTemperatureBelow: 'Temperatura de {{temperature}} ºC por debajo del mínimo ({{min}} ºC)',
    reasonTemperature: 'Temperatura de {{temperature}} ºC fuera de rango',
    reasonTemperatureUnknown: 'Temperatura fuera de rango',
    reasonPackagingKo: 'Envasado no conforme',
    reasonLabelingKo: 'Etiquetado no conforme',
    reasonDecisionRejected: 'Rechazado en el control de recepción',
    reasonDecisionAcceptedWithIncident: 'Aceptado con incidencia',
    reasonSelfCheckFailed: 'Autocontrol no superado',
    reasonUnknown: 'Motivo: {{code}}',
    // Resumen de una NC de autocontrol
    selfCheckFailedRange: '{{label}}: {{value}} (rango {{min}} a {{max}})',
    selfCheckFailedBelowMin: '{{label}}: {{value}} (mínimo {{min}})',
    selfCheckFailedAboveMax: '{{label}}: {{value}} (máximo {{max}})',
    selfCheckFailedValue: '{{label}}: {{value}}',
    selfCheckFailedKo: '{{label}}: KO',
    selfCheckFailedUnnamed: 'Un punto del autocontrol no ha pasado',
  },
} as const;
